var _rect, _rect2, _rect3, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndianflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 39,
    height: 10,
    fill: "#FF671F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10.5,
    width: 39,
    height: 10,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20.5,
    width: 39,
    height: 10,
    fill: "#046A38"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15.5,
    r: 4.75,
    fill: "white",
    stroke: "#06038D",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5L20.2493 13.6065L21.2941 10.6704L20.7309 13.7355L22.5 11.1699L21.1626 13.9848L23.5355 11.9645L21.5152 14.3374L24.3301 13L21.7645 14.7691L24.8296 14.2059L21.8935 15.2507L25 15.5L21.8935 15.7493L24.8296 16.7941L21.7645 16.2309L24.3301 18L21.5152 16.6626L23.5355 19.0355L21.1626 17.0152L22.5 19.8301L20.7309 17.2645L21.2941 20.3296L20.2493 17.3935L20 20.5L19.7507 17.3935L18.7059 20.3296L19.2691 17.2645L17.5 19.8301L18.8374 17.0152L16.4645 19.0355L18.4848 16.6626L15.6699 18L18.2355 16.2309L15.1704 16.7941L18.1065 15.7493L15 15.5L18.1065 15.2507L15.1704 14.2059L18.2355 14.7691L15.6699 13L18.4848 14.3374L16.4645 11.9645L18.8374 13.9848L17.5 11.1699L19.2691 13.7355L18.7059 10.6704L19.7507 13.6065L20 10.5Z",
    fill: "#06038D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndianflag);
export default __webpack_public_path__ + "static/media/indianflag.0e1c5d333f6a679e397fe4486aa564f9.svg";
export { ForwardRef as ReactComponent };